import { Capacitor } from '@capacitor/core';
import React from 'react';
import { Form } from 'react-bootstrap';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Loader from 'react-loader-spinner';
import { takePicture } from '../../../capacitor/imageUpload';
import { getLocalStorage, isMobileApp } from '../../../common/common';
import LazyImage from '../../../components/CustomLibraries/LazyImage';
import { BsUpload, RiDeleteBin6Line } from '../../../components/icons';
const AnswerTypeUpload = ({
  data,
  qNo,
  onTextCheck,
  isReview,
  fileUpload,
  cancelClick,
  appFileUpload,
  backdrop = false
}) => {
  const userDetails = () => getLocalStorage('user', {});

  // const postMessageReactNative = (e) => {
  //   // if (isApp() && isAndroid) {
  //   //   e.preventDefault();
  //   //   if (window.ReactNativeWebView) {
  //   //     window.ReactNativeWebView.postMessage(
  //   //       JSON.stringify({
  //   //         type: OPEN_CAMERA,
  //   //         payload: {
  //   //           user_master_id: userDetails()?.user_master_id ?? 0,
  //   //           type: 'file'
  //   //         }
  //   //       })
  //   //     );
  //   //   } else {
  //   //     alert('This operation is not permitted');
  //   //   }
  //   // }

  //   if (Capacitor.getPlatform() == 'ios' || 'android') {
  //     // console.log("platform at profile ==>", Capacitor.getPlatform())
  //     takePicture((compressedFile) => {
  //       if (!compressedFile) {
  //         return false
  //       }
  //       // console.log('compressedFile', compressedFile);
  //       // handleCompressedUpload(largeFile, (compressedFile) => {
  //       CapacitorFirebaseUpload(
  //         compressedFile,
  //         firebaseToken,
  //         ['jpg', 'jpeg', 'png'],
  //         (_p) => setProgress(_p),
  //         (url, fileName) => {
  //           qArray[questionNo].attachedFile = {
  //             type: file.type,
  //             url
  //           };
  //           log('modified', qArray);
  //           setProgress(0);
  //         },
  //         () => {
  //           setBackdrop(false);
  //           setProgress(0);
  //         }
  //       );
  //       // })

  //     })

  //   }

  // };

  const postMessageReactNative = () => {
    if (Capacitor.getPlatform() == 'ios' || 'android') {
      takePicture((compressedFile) => {
        appFileUpload(compressedFile);
      });
    }
  };
  return (
    <div className="w-100 spqAswerTypeText">
      {!isReview && (
        <div className="col-md-4 col-12 mb-4">
          <div className="cmnFileUpload text-black fs-16 text-center rounded position-relative overflow-hidden w-100 border border-light py-20 px-4">
            {backdrop ? (
              <div>Uploading File</div>
            ) : (
              <>
                <div onClick={() => isMobileApp() && postMessageReactNative()}>
                  <BsUpload customClass="fs-2 me-2" />
                  Choose File
                </div>
                {!isMobileApp() && (
                  <input
                    className="cmnFileUploadInput position-absolute top-0 start-0 w-100 h-100 z-1 opacity-0"
                    type="file"
                    id="formFile"
                    accept="image/*,application/pdf"
                    // onClick={(e) => postMessageReactNative(e)}
                    onChange={(e) => fileUpload(e.target.files[0])}
                  />
                )}
              </>
            )}
          </div>
        </div>
      )}
      {backdrop ? (
        <Loader
          type="ThreeDots"
          className="text-center text-primary opacity-75"
          color="currentColor"
          height={70}
          width={70}
        />
      ) : (
        data?.attachedFile && (
          <div className="row cmnFileUploadShow my-4 mt-n3 ms-n3">
            <div className="col-md-2 col-4 cmnFileUploadBox ps-3 mt-3">
              <div className="cmnFileUploadBoxIn rounded position-relative overflow-hidden">
                <LazyImage
                  src={
                    data?.attachedFile.type != 'application/pdf'
                      ? data?.attachedFile?.url
                      : 'https://cdn-icons-png.flaticon.com/512/337/337946.png'
                  }
                  className="object-fit-cover w-100 h-100 float-start"
                  fallback_image={'https://webptojpgs.com/ppp.png'}
                />
                {!isReview && (
                  <a
                    href="javascript:void(0)"
                    className="cmnFileUploadRemove rounded position-absolute d-flex justify-content-center align-items-center bg-white bg-opacity-75"
                    onClick={cancelClick}
                  >
                    <RiDeleteBin6Line customClass="fs-2 text-danger" />
                  </a>
                )}
              </div>
            </div>
          </div>
        )
      )}
      {/* {data?.attachedFile && (
        <div className="row cmnFileUploadShow my-3">
          <div className="col-md-2 col-4 cmnFileUploadBox">
            <div className="cmnFileUploadBoxIn rounded">
              <LazyImage
                src={
                  data?.attachedFile.type != 'application/pdf'
                    ? data?.attachedFile?.url
                    : 'https://cdn-icons-png.flaticon.com/512/337/337946.png'
                }
                className="object-fit-cover w-100 h-100 float-start"
                fallback_image={'https://webptojpgs.com/ppp.png'}
              />
              {!isReview && (
                <a
                  href="javascript:void(0)"
                  className="cmnFileUploadRemove rounded"
                  onClick={cancelClick}
                >
                  <RiDeleteBin6Line customClass="fs-2 text-danger" />
                </a>
              )}
            </div>
          </div>
        </div>
      )} */}
      {isReview && !data?.textAnswer
        ? null
        : data?.usercomment_flag == 1 && (
            <FloatingLabel
              controlId="floatingTextarea2"
              label={`${!isReview ? 'Type Your Answer' : ''}`}
            >
              <Form.Control
                readOnly={isReview}
                className="fs-4 p-4"
                as="textarea"
                placeholder="Answer"
                value={data?.textAnswer}
                onChange={(e) => {
                  onTextCheck(e.target.value);
                }}
              />
            </FloatingLabel>
          )}
    </div>
  );
};

export default AnswerTypeUpload;
